import { HttpParams } from '@angular/common/http';
import { SimpleChange } from '@angular/core';
import { throwError } from 'rxjs';

export class CommonUtil {
	static removeEmptyQueryParams(params: any): object {
		return Object.keys(params).reduce((accumulator: any, key: string) => {
			if (params[key] !== '' && !(Array.isArray(params[key]) && !params[key].length)) {
				accumulator[key] = params[key];
			} else {
				accumulator[key] = null;
			}

			return accumulator;
		}, {});
	}

	static handleNgOnChanges(prop: SimpleChange, callback: (value: any) => void): void {
		if (prop !== undefined && prop.currentValue !== undefined) {
			callback(prop.currentValue);
		}
	}

	static createHttpParams(json: object): HttpParams {
		let params = new HttpParams();

		Object.entries(json).forEach(([key, value]) => {
			if (key && value) {
				params = params.set(key, value);
			}
		});

		return params;
	}

	/**
	 * Check if object is empty or not.
	 *
	 * @param object The object needs to checked.
	 * @returns An boolean if object is empty.
	 */
	static isEmptyObject = <T>(object: T): boolean => {
		return !object || (object && !Object.keys(object).length);
	};

	static handleError = (error: any): any => {
		let errorMessage = '';

		if (error.error instanceof ErrorEvent) {
			// client-side error
			errorMessage = `Error: ${error.error.message}`;
		} else {
			// server-side error
			errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		}

		return throwError(() => {
			return errorMessage;
		});
	};

	/**
	 * Check if string is empty.
	 */
	static isEmptyString = (value: string): boolean => {
		return value == null || (typeof value === 'string' && value.trim().length === 0);
	};
}
